import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../globalStyle/GlobalStyle";
import { PageStyle } from "./styled";
import { Card } from "../../layout/AuthLayout.styled";

function Unauthorized() {
	const navigate = useNavigate();
	return (
		<PageStyle>
			<Card>
				<h1>401 ERROR</h1>
				<p>You are not authorized to view this page.</p>

				<Button
					onClick={() => {
						navigate("/");
					}}>
					Go Back
				</Button>
			</Card>
		</PageStyle>
	);
}

export default Unauthorized;
